import { MKT } from 'src/sections/@dashboard/marketing/marketing.design';

export const RASTREAMENTO_DESIGN = {
    ...MKT,
    page: {
        ...MKT.page,
        root: 'flex flex-col min-h-full w-full bg-[#f4f4f7] text-[#18181b] animate-in fade-in slide-in-from-bottom-4 duration-500',
        fontStack: "'Plus Jakarta Sans', Manrope, ui-sans-serif, system-ui, sans-serif",
        container: 'w-full px-4 md:px-6 lg:px-8',
        pageBody: 'pb-[120px]',
        stickyHeader: 'sticky top-0 z-30 bg-white border-b border-[#e7e7ec]',
        topbar: 'flex flex-col md:flex-row md:items-start gap-4 pt-[18px] pb-[18px]',
        topbarIdentity: 'flex items-start gap-3.5 min-w-0 flex-1',
        iconTile:
            'flex items-center justify-center flex-shrink-0 w-[42px] h-[42px] rounded-[10px] bg-[#ede9fe] text-[#6d28d9]',
        headerTitle: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b]',
        headerSubtitle: 'mt-[5px] text-[13px] text-[#71717a] leading-[1.5]',
        topbarActions: 'flex items-center gap-2.5 flex-shrink-0 flex-wrap md:pt-[5px]',
        primaryButton:
            'inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-[10px] bg-gradient-to-b from-[#8b5cf6] to-[#7c3aed] text-white text-[14px] font-semibold whitespace-nowrap shadow-[0_2px_8px_rgba(124,58,237,.32)] transition-colors hover:from-[#7c3aed] hover:to-[#6d28d9] disabled:from-[#e4e4e7] disabled:to-[#e4e4e7] disabled:text-[#a1a1aa] disabled:shadow-none disabled:cursor-not-allowed',
        filterBar: 'flex flex-wrap items-end gap-3 mb-4',
        filterItem: 'min-w-0',
        filterLabel: 'text-[10px] font-semibold text-[#a1a1aa] uppercase tracking-wider mb-1 block',
        filterSelect:
            'h-9 w-[150px] md:w-[170px] text-xs rounded-lg border border-[#d4d4d8] bg-white px-3 text-[#18181b] shadow-none hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus:ring-2 focus:ring-[#c4b5fd]',
    },
    table: {
        ...MKT.table,
        // As colunas de captura (leads + tipo) entraram sem alargar a tabela:
        // plataforma/status/datas cederam largura, senao a linha estoura o
        // container e o overflow-x do GenericTable vira barra permanente.
        cols: {
            nome: 'flex-1 min-w-[180px] pr-4',
            plataforma: 'w-[150px]',
            status: 'w-[120px]',
            leads: 'w-[90px]',
            captura: 'w-[130px]',
            inicio: 'w-[130px]',
            fim: 'w-[130px]',
            acoes: 'w-[100px] flex items-center justify-end gap-1',
        },
    },
    form: {
        hint: 'text-xs text-muted-foreground',
        // Caixa de aviso dos campos de CTWA (sem canal conectado, sem anuncio
        // observado): mesma superficie do bloco de palavras-chave do modal.
        notice: 'border border-border rounded-xl p-4 bg-muted/30 space-y-3',
    },
    // Toggle de modo de captura (anuncio x palavra-chave) no topo do modal —
    // as 2 opcoes sao mutuamente exclusivas, entao o selecionado usa a cor de
    // marca cheia (nao so texto violeta como o `tabs` compartilhado) pra ficar
    // obvio que e uma escolha binaria, nao um filtro.
    captureMode: {
        container: 'grid grid-cols-2 gap-2',
        option: 'flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl border border-border bg-card text-sm font-medium text-muted-foreground transition-all hover:border-violet-300 dark:hover:border-violet-500/40 hover:text-foreground',
        optionActive: 'flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl border border-[#7C3AED] bg-[#7C3AED] text-sm font-semibold text-white shadow-sm shadow-[#7C3AED]/20 transition-all',
    },
};

const STATUS_TONES = {
    ativa: 'success',
    pausada: 'warning',
    finalizada: 'neutral',
    erro: 'danger',
};

const STATUS_LABEL_KEYS = {
    ativa: 'tracking.status.active',
    pausada: 'tracking.status.paused',
    finalizada: 'tracking.status.finished',
    erro: 'tracking.status.error',
};

export function getStatusMeta(status, t) {
    const tone = STATUS_TONES[status] ?? 'neutral';
    const labelKey = STATUS_LABEL_KEYS[status];
    return {
        label: labelKey ? t(labelKey) : (status ?? '—'),
        tone,
    };
}

// Como a campanha pega o lead: canal vinculado = anuncio Click-to-WhatsApp,
// sem canal = o casamento antigo por palavra-chave da primeira mensagem.
// Mesmo molde de getStatusMeta — vocabulario de dominio aqui, cor no TONE.
export function getCaptureMeta(temCanal, t) {
    return temCanal
        ? { label: t('tracking.capture.ad'), tone: 'brand', icon: 'mdi:bullhorn-outline' }
        : { label: t('tracking.capture.keyword'), tone: 'neutral', icon: 'mdi:key-outline' };
}
